import { render } from "./BigTerms.vue?vue&type=template&id=27e823a5&scoped=true"
import script from "./BigTerms.vue?vue&type=script&lang=js"
export * from "./BigTerms.vue?vue&type=script&lang=js"

import "./BigTerms.vue?vue&type=style&index=0&id=27e823a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e823a5"]])

export default __exports__